import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useState, useEffect } from "react";

// Pages
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import StoreEditor from "@/pages/StoreEditor";
import ProductManager from "@/pages/ProductManager";
import StoreAnalytics from "@/pages/StoreAnalytics";
import ThemeEditor from "@/pages/ThemeEditor";
import PublicStore from "@/pages/PublicStore";
import PublicProduct from "@/pages/PublicProduct";
import ProtectedRoute from "@/components/ProtectedRoute";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (must be synchronous during render)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      
      {/* Protected Routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/store/:storeId/edit" element={
        <ProtectedRoute>
          <StoreEditor />
        </ProtectedRoute>
      } />
      <Route path="/store/:storeId/products" element={
        <ProtectedRoute>
          <ProductManager />
        </ProtectedRoute>
      } />
      <Route path="/store/:storeId/analytics" element={
        <ProtectedRoute>
          <StoreAnalytics />
        </ProtectedRoute>
      } />
      <Route path="/store/:storeId/theme" element={
        <ProtectedRoute>
          <ThemeEditor />
        </ProtectedRoute>
      } />
      
      {/* Public Store Routes */}
      <Route path="/s/:slug" element={<PublicStore />} />
      <Route path="/s/:slug/product/:productId" element={<PublicProduct />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-manrope">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;